import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useCallback } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  tipoPesquisa: number,
  valueField: string,
  onTipoPesquisaChange: (novoTipoPesquisa: number) => void,
  onValueFieldChange: (value: string) => void,
};

export const Header = ({
  tipoPesquisa,
  valueField,
  onTipoPesquisaChange,
  onValueFieldChange,
}: Props) => {
  const handleTipoPesquisaChange = useCallback((e: SelectChangeEvent<number>) => {
    onTipoPesquisaChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onTipoPesquisaChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            <div className="flex col-span-3 gap-1">
              <FormControl size="small" sx={{ width: "275px" }}>
                <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
                <Select
                  size="small"
                  labelId="modulo-dashboard"
                  label="Pesquisar por"
                  value={tipoPesquisa}
                  onChange={handleTipoPesquisaChange}>
                  <MenuItem value={1}>Número</MenuItem>
                  <MenuItem value={2}>Descrição</MenuItem>
                </Select>
              </FormControl>

              <div className="w-full">
                <DefaultInput
                  label="Pesquisar"
                  name="search_by_value_field"
                  value={valueField}
                  onChangeValue={onValueFieldChange} />
              </div>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}